export default __webpack_public_path__ + "static/N0082-de66c8f86dc0394927fdc1f9ca6c94ca.png";